// extracted by mini-css-extract-plugin
module.exports = {"images":"styles_images__74iaJ","image":"styles_image__KHLUJ","spin":"styles_spin__1guSf"};